import { groupBySection, type PlanValueRow } from './change-format'
import { useTranslations } from "next-intl"
import { usePlanPresentation } from "./use-plan-presentation"



export function PlanDetails({ rows }: { rows: PlanValueRow[] }) {
  const presentation = usePlanPresentation()

  const tUi = useTranslations("Billing.BillingPlanEditorPlanDetails")

  return (
    <div className="space-y-5">
      {groupBySection(rows, presentation).map(group => (
        <section key={group.id} aria-label={group.title} className="space-y-2">
          <h3 className="text-sm font-semibold">{group.title}</h3>
          <dl className="grid gap-x-4 gap-y-2 text-sm sm:grid-cols-2">
            {group.rows.map(row => (
              <div key={row.field} className="min-w-0">
                <dt className="text-xs text-muted-foreground">{row.label}</dt>
                <dd className="mt-0.5 break-words">
                  <span>{row.value}</span>
                  {row.inactive ? <span className="block text-xs text-muted-foreground"><span key={tUi("savedCurrentlyInactive")}>{tUi("savedCurrentlyInactive")}</span></span> : null}
                </dd>
              </div>
            ))}
          </dl>
        </section>
      ))}
    </div>
  )
}
